export default "__VITE_ASSET__XZUMPsZO__"